export default __webpack_public_path__ + "static/media/job_offer15_xl.06c5e043.jpg";